/**
 * @file Redux mappers for composeMetaTitle container
 */

import { MapDispatchToProps, MapStateToProps } from 'react-redux';

import AppState from '../../../models/state';
import { updateDraftTextRequest } from '../../../store/actions/draftsText';

import { DispatchProps, OwnProps, StateProps } from './types';

/**
 * Map Redux dispatch actions to component props
 *
 * @param dispatch          Redux dispatch function
 * @param ownProps          Props passed to the container
 * @param ownProps.nodeType The ID of the draft
 * @returns                 Mapped props
 */
export const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = (
  dispatch,
  { nodeType },
) => ({
  /**
   * Dispatches request to update text draft
   *
   * @param text Text for the draft
   *
   * @returns    void
   */
  requestTextUpdate: text => dispatch(updateDraftTextRequest(nodeType, text)),
});

/**
 * Map Redux state to container props
 *
 * @param appState          App state
 * @param appState.drafts   Drafts data
 * @param ownProps          Props passed to the container
 * @param ownProps.nodeType Draft ID
 * @returns                 Mapped props
 */
export const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = ({ drafts }, { nodeType }) => {
  const draft = drafts.get(nodeType);

  return {
    nodeId: draft?.nodeId ?? null,
    text: draft?.text ?? '',
  };
};
